import { Component, Input } from '@angular/core';

export type RealEstateListingPreviewLayout = 'card' | 'inline';

export interface RealEstateListingPreviewData {
	price?: number;
	sqft?: number;
	bedrooms?: number | null;
	bathrooms?: number | string | null;
	address?: string;
}

@Component({
	selector: 'app-real-estate-listing-preview',
	templateUrl: './real-estate-listing-preview.component.html',
	styleUrls: ['./real-estate-listing-preview.component.scss']
})
export class RealEstateListingPreviewComponent {
	@Input() layout: RealEstateListingPreviewLayout = 'card';
	@Input() imageUrl: string | null = null;
	@Input() imageAlt = 'Promoted property';
	@Input() showImagePlaceholder = false;

	@Input() listing: RealEstateListingPreviewData | null = null;
	@Input() showAddress = false;
	@Input() loadingDetails = false;

	get shouldRenderImageColumn(): boolean {
		return !!this.imageUrl || this.showImagePlaceholder;
	}
}
